import http from 'plugins/axios';

export default {
  getAllCoins() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  },
  getStatistics({from, to, coinType, page, size}) {
    return http.get({
      url: '/admin/statistics/platform',
      data: {
        coinType,
        from,
        to,
        page,
        size
      }
    });
  }
};
